import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useTasyarBrand } from '../lib/tasyarBrand';
import { XIcon, InstagramIcon, SnapchatIcon, TikTokIcon, YouTubeIcon } from '../components/icons/SocialIcons';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const SOCIALS = [
  { key: 'twitter_url', label: 'X (تويتر)', Icon: XIcon },
  { key: 'instagram_url', label: 'انستقرام', Icon: InstagramIcon },
  { key: 'snapchat_url', label: 'سناب شات', Icon: SnapchatIcon },
  { key: 'tiktok_url', label: 'تيك توك', Icon: TikTokIcon },
  { key: 'youtube_url', label: 'يوتيوب', Icon: YouTubeIcon },
];

export default function CoachFooter() {
  const brand = useTasyarBrand();
  const [settings, setSettings] = useState({});

  useEffect(() => {
    axios.get(`${API}/platform/settings`).then((res) => setSettings(res.data || {})).catch(() => {});
  }, []);

  const links = SOCIALS.filter((s) => settings[s.key]);

  return (
    <footer className="mt-8 border-t border-slate-200 bg-white px-4 py-5 pb-24 text-center sm:px-6 lg:pb-5" data-testid="coach-footer">
      {links.length > 0 && (
        <div className="mb-3 flex items-center justify-center gap-3" data-testid="coach-footer-socials">
          {links.map(({ key, label, Icon }) => (
            <a
              key={key}
              href={settings[key]}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={label}
              title={label}
              data-testid={`coach-footer-social-${key}`}
              className="flex h-8 w-8 items-center justify-center rounded-full bg-slate-100 text-slate-500 transition-colors hover:bg-teal-500 hover:text-white"
            >
              <Icon className="h-4 w-4" />
            </a>
          ))}
        </div>
      )}
      <p className="text-xs font-medium text-slate-400" data-testid="coach-footer-copyright">
        © {new Date().getFullYear()} {brand.name} — جميع الحقوق محفوظة
      </p>
    </footer>
  );
}
